import React from 'react';
import { Typography, Box, Rating } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import StarIcon from '@mui/icons-material/Star';
import InfoIcon from '@mui/icons-material/Info';
import MyTooltip from '../../../../Utils/Tooltip/Tooltip';

const RATING_NOTE =
  'An overall plan rating based on how generous the match is and how quickly you gain full ownership of it.';

const useStyles = makeStyles((theme) => ({
  header: {
    padding: theme.spacing(2.5, 0, 2),
    marginBottom: theme.spacing(0),
  },
  planNameWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
    flexWrap: 'wrap',
  },
  planName: {
    fontSize: '2.2rem',
    fontWeight: 800,
    color: '#000000',
    letterSpacing: '-0.02em',
    [theme.breakpoints.down('sm')]: {
      fontSize: '2rem',
    },
  },
  infoIcon: {
    fontSize: '1.25rem',
    color: '#94A3B8',
    cursor: 'pointer',
    marginLeft: theme.spacing(-0.5),
    '&:hover': {
      color: '#4361EE',
    },
  },
}));

const PlanHeader = ({
  planName,
  rating,
  planLabel = '401(k)',
  ratingNote = RATING_NOTE,
  appendPlanSuffix = true,
}) => {
  const classes = useStyles();
  const normalizedLabel = String(planLabel).toLowerCase();
  const formattedPlanName = appendPlanSuffix
    ? planName?.toLowerCase().includes(normalizedLabel)
      ? planName
      : `${planName} ${planLabel} Plan`
    : planName;

  return (
    <header className={classes.header}>
      <Box className={classes.planNameWrapper}>
        <Typography variant="h3" className={classes.planName}>
          {formattedPlanName}
        </Typography>
        {rating !== undefined && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Rating
              value={rating}
              readOnly
              size="large"
              emptyIcon={
                <StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />
              }
            />
            <MyTooltip
              title={ratingNote}
              render={() => <InfoIcon className={classes.infoIcon} />}
            />
          </Box>
        )}
      </Box>
    </header>
  );
};

export default PlanHeader;
